import React from "react";
import module_style from "./CreatorMiscellaneousData/style.module.css";
import style from "../style.module.css";
import { Input, Button, Textarea } from "@my-scoot/component-library-legacy";
import InfoOutlined from "@material-ui/icons/InfoOutlined";
import AddCircle from "@material-ui/icons/AddCircle";
import ExlyModal from "common/Components/ExlyModal";
import { is_empty } from "utils/validations";
import { api, dataProvider } from "data";
import constants from "constants/constants";
import { useNotifications } from "utils/hooks";
import { ImageUploader } from "ui/pages/TemplatePreview/widgets";
import AdditionalPointersList from "./CreatorMiscellaneousData/Components/AdditionalPointersList";
import {
  refreshIframe,
  validateData,
  findSelectedData,
} from "./CreatorMiscellaneousData/Utils";
import placeholderImg from "assets/images/image-uploader-placeholder.png";
import { WebpageCreationContext } from "ui/pages/TemplatePreview";
import {
  AdditionalPointersConfig,
  SIDEBAR_SECTIONS,
  SIDEBAR_KEYS,
  SECTIONKEY_TO_MISC_KEY,
} from "ui/pages/TemplatePreview/constants";
import useSetMissceleneous from "./common/useSetMissceleneous";
import { handleErrors } from "./common/validator";
import useTemplatePreview from "ui/pages/TemplatePreview/hooks/useTemplatePreview";
import { isRequestSuccessful } from "utils/Utils";
import { creator_miscellaneous_data_types } from "features/Common/modules/CreatorData/CreatorData.constants";
import { IMAGE_SECTION_KEY_PATH } from "features/Common/modules/ExlyImage/constants/ExlyImage.constants";
import SectionVisibilityToggle from "./hideShow";
import { handleVisibilityToggle } from "../utils";
import useVisibilityMutations from "../useVisibilityMutations.hook";

const formData = {
  title: {
    key: "title",
    label: "Heading",
  },
  description: {
    key: "description",
    label: "Description",
  },
  bannerImage: {
    key: "additional_pointers_cover",
  },
};

export const AdditionalPointers = (props) => {
  const { disableAllEdits, state } = props;
  const { notify } = useNotifications();
  const { miscellaneous_data, fetchMiscellaneousData, set_miscellaneous_data } =
    React.useContext(WebpageCreationContext);
  const { pushNotif } = useTemplatePreview();

  const [section_name, set_section_name] = React.useState("More About Us");
  const [section_heading, set_section_heading] = React.useState("");
  const [show_modal, set_show_modal] = React.useState(false);
  const [uuid, set_uuid] = React.useState(null);
  const [processing, set_processing] = React.useState(false);
  const [selected_id, set_selected_id] = React.useState(null);
  const [data, set_data] = React.useState([]);
  const [pre_edit_data, set_pre_edit_data] = React.useState(null);
  const [error_object, set_error_object] = React.useState({});
  const [visible, set_visible] = React.useState(true);

  // Mutations for visibility toggle
  const { createMutation, updateMutation } = useVisibilityMutations();

  React.useEffect(() => {
    assignData();
  }, []);

  React.useEffect(() => {
    // Taking 0th element of miscellaneous_data - additionalPointers as latest to update
    if (!is_empty(miscellaneous_data?.additionalPointers)) {
      const [additionalPointersData] = miscellaneous_data.additionalPointers;
      if (additionalPointersData?.uuid) {
        set_uuid(additionalPointersData?.uuid);
      }
    }
  }, [miscellaneous_data]);

  useSetMissceleneous({
    listeners: [data, section_name, section_heading, uuid, visible],
    data: {
      ...miscellaneous_data,
      additionalPointers: [
        {
          ...(uuid && {
            uuid,
          }),
          section_name,
          data: {
            section_heading: section_heading,
            section_name: section_name,
            visible,
            data: data,
          },
        },
      ],
    },
    updateHandler: {
      additionalPointers: {
        handleSave: () => handleSave(),
      },
    },
  });

  const assignData = () => {
    try {
      if (is_empty(miscellaneous_data?.additionalPointers)) return;
      let temp = miscellaneous_data?.additionalPointers[0];
      set_data(temp?.data?.data);
      set_section_name(temp?.data?.section_name);
      set_section_heading(temp?.data?.section_heading);
      set_uuid(temp?.uuid);

      // SAFETY NET: default visible = true
      set_visible(temp?.data?.visible ?? true);
    } catch (err) {
      console.error("assign brands err", err);
      notify(
        err?.body?.message ? err?.body?.message : constants.error_message,
        "error"
      );
    }
  };

  const handleSave = async () => {
    try {
      if (processing) return;
      set_processing(true);
      const selected_data = findSelectedData(data, selected_id);
      const error_obj = validateData(selected_data, "Required");

      if (!is_empty(error_obj)) {
        set_error_object(Object.assign(error_object, error_obj));
        return notify("Invalid form values", "error");
      }

      let payload, api_resource;
      let temp = data;
      if (temp[selected_id]?.draft) {
        delete temp[selected_id].draft;
      }
      // Taking 0th element of miscellaneous_data - additionalPointers as latest to update
      let api_uuid = uuid;
      if (!is_empty(miscellaneous_data?.additionalPointers)) {
        const [additionalPointersData] = miscellaneous_data.additionalPointers;
        if (additionalPointersData?.uuid) {
          api_uuid = additionalPointersData?.uuid;
        }
      }
      if (is_empty(api_uuid)) {
        api_resource = api.creator_miscellaneous_data.create;
        payload = {
          type: creator_miscellaneous_data_types.ADDITIONAL_POINTERS,
          data: { section_name, section_heading, visible, data: temp },
        };
      } else {
        api_resource = api.creator_miscellaneous_data.update;
        payload = {
          uuid: api_uuid,
          updated_values: {
            data: { section_name, section_heading, visible, data: temp },
          },
        };
      }
      const status = await dataProvider.custom_request(
        api_resource,
        "POST",
        payload
      );
      if (isRequestSuccessful(status.status)) {
        refreshIframe();
        set_show_modal(false);
        set_selected_id(null);
        set_pre_edit_data(null);
        set_error_object({});
        set_data([...temp]);

        if (is_empty(api_uuid)) {
          fetchMiscellaneousData({
            type: creator_miscellaneous_data_types.ADDITIONAL_POINTERS,
          });
        }
      }
      pushNotif(status?.message);
    } catch (err) {
      console.error(err);
      notify(
        err?.body?.message ? err?.body?.message : constants.error_message,
        "error"
      );
    } finally {
      set_processing(false);
    }
  };

  const handleDelete = () => {
    let temp = data;
    temp.splice(parseInt(selected_id), 1);
    for (let i = 0; i < temp.length; i++) {
      temp[i].id = i;
    }
    set_data([...temp]);
    handleSave();
  };

  const handleEdit = () => {
    const edit_data = findSelectedData(data, selected_id);
    set_pre_edit_data({ ...edit_data });
    set_show_modal(true);
  };

  const updateData = (value, key) => {
    let temp = data;
    temp[selected_id][key] = value;
    set_data([...temp]);
  };

  const handleModalClose = () => {
    set_show_modal(false);
    set_error_object({});

    // remove draft entries and updating edit value
    let published_data = data.filter((item) => !item.draft);
    if (pre_edit_data) {
      published_data = data.map((item) =>
        item?.id === selected_id ? pre_edit_data : item
      );
      set_pre_edit_data(null);
    }
    set_data([...published_data]);
  };

  const onToggleVisibility = () =>
    handleVisibilityToggle({
      currentVisible: visible,
      setVisible: set_visible,
      miscellaneousData: miscellaneous_data,
      sectionKey: SECTIONKEY_TO_MISC_KEY[SIDEBAR_KEYS.ADDITIONAL_POINTERS],
      sectionType: creator_miscellaneous_data_types.ADDITIONAL_POINTERS,
      defaultSectionName:
        SIDEBAR_SECTIONS[SIDEBAR_KEYS.ADDITIONAL_POINTERS].title,
      fetchMiscellaneousData,
      set_miscellaneous_data,
      createMutation: createMutation,
      updateMutation: updateMutation,
    });

  return (
    <div>
      <SectionVisibilityToggle
        visible={visible}
        disabled={disableAllEdits}
        onToggle={onToggleVisibility}
      />

      <div className={style.label}>
        What would you like to call this section?
      </div>

      <div className={`mt-2`}>
        <Input
          fullWidth
          value={section_name}
          error={error_object?.sectionNameLength}
          helperText={error_object?.sectionNameLength}
          inputProps={{
            maxLength:
              AdditionalPointersConfig.maxTitleLength[state?.template?.slug],
          }}
          onChange={(e) => {
            let value = e.target.value;

            if (
              value.length >=
              AdditionalPointersConfig.maxTitleLength[state?.template?.slug]
            ) {
              set_error_object({
                ...error_object,
                sectionNameLength: `Maximum field length of ${
                  AdditionalPointersConfig.maxTitleLength[state?.template?.slug]
                } reached.`,
              });
            } else {
              set_error_object({ ...error_object, sectionNameLength: false });
            }
            set_section_name(value);
          }}
          disabled={disableAllEdits}
        />
      </div>

      <div className={`${style.label} mt-3`}>Heading</div>

      <div className={`mt-2`}>
        <Input
          fullWidth
          value={section_heading}
          error={error_object?.sectionHeadingLength}
          helperText={error_object?.sectionHeadingLength}
          inputProps={{
            maxLength:
              AdditionalPointersConfig.maxTitleLength[state?.template?.slug],
          }}
          onChange={(e) => {
            let value = e.target.value;

            if (
              value.length >=
              AdditionalPointersConfig.maxTitleLength[state?.template?.slug]
            ) {
              set_error_object({
                ...error_object,
                sectionHeadingLength: `Maximum field length of ${
                  AdditionalPointersConfig.maxTitleLength[state?.template?.slug]
                } reached.`,
              });
            } else {
              set_error_object({
                ...error_object,
                sectionHeadingLength: false,
              });
            }
            set_section_heading(value);
          }}
        />
      </div>

      <div className={`my-3 ${style.info}`}>
        <InfoOutlined className={`${style.infoIcon}`} />
        The items can be dragged up and down using the &#10303; icon to change
        the order in which they appear.
      </div>

      {!is_empty(data) && (
        <AdditionalPointersList
          data={data}
          set_data={(value) => set_data(value)}
          set_show_modal={(value) => set_show_modal(value)}
          handleEdit={() => handleEdit()}
          uuid={uuid}
          handleDelete={() => handleDelete()}
          selected_id={selected_id}
          set_selected_id={(value) => set_selected_id(value)}
          disableAllEdits={disableAllEdits}
        />
      )}

      <div className={`d-flex mt-4 align-items-center justify-content-between`}>
        {disableAllEdits ? (
          <div />
        ) : (
          <div
            onClick={() => {
              let initial_data = {
                id: data.length,
                title: "",
                additional_pointers_cover: "",
                description: "",
                draft: true,
              };
              set_selected_id(data.length);
              set_data([...data, initial_data]);
              set_show_modal(true);
            }}
            className={`${module_style.action_color} ${module_style.text_cta} pointer`}
          >
            <AddCircle />
            <span className={`ml-2`}>Add pointer</span>
          </div>
        )}

        <Button
          variant="contained"
          color="primary"
          disableElevation
          disabled={processing || disableAllEdits}
          loading={processing}
          onClick={handleSave}
        >
          Save
        </Button>
      </div>

      <ExlyModal
        title="Add Pointer"
        open={show_modal}
        onClose={handleModalClose}
        primaryBtnText={processing ? "..." : "Save"}
        onPrimaryBtnClick={handleSave}
        modal_props={{
          modalPaperClassName: module_style.miscellaneous_data_modal,
        }}
      >
        <div>
          <div className={`${style.label} ${style.required} mb-1 mt-3`}>
            {formData.title.label}
          </div>
          <Input
            placeholder="Eg: Get set fit (5 weeks Challenge)"
            error={error_object?.title}
            helperText={error_object?.title}
            fullWidth
            value={data[selected_id]?.title}
            inputProps={{
              maxLength:
                AdditionalPointersConfig.maxHeadingLength[
                  state?.template?.slug
                ],
            }}
            onChange={(e) => {
              let value = e.target.value;

              const error = handleErrors(
                error_object,
                formData.title.key,
                value,
                AdditionalPointersConfig.maxHeadingLength[state?.template?.slug]
              );
              set_error_object(error);
              updateData(value, formData.title.key);
            }}
          />

          <div className={`${style.label} ${style.required} mt-3 mb-1`}>
            {formData.description.label}
          </div>
          <Textarea
            error={error_object?.description}
            helperText={error_object?.description}
            placeholder="Eg: Learn how to stay fit without going to the gym"
            value={data[selected_id]?.description}
            maxLength={
              AdditionalPointersConfig.maxDescLength[state?.template?.slug]
            }
            onChange={(e) => {
              let value = e.target.value;

              const error = handleErrors(
                error_object,
                formData.description.key,
                value,
                AdditionalPointersConfig.maxDescLength[state?.template?.slug]
              );
              set_error_object(error);
              updateData(value, formData.description.key);
            }}
            minWidth="100%"
          />

          <div className={`${style.label} mt-3 mb-1`}>
            <div className={`${style.required}`}>Upload Banner Image</div>
            <div className={style.info}>
              Recommended format: 400 x 300 pixels (PNG or JPG)
            </div>
          </div>
          <div className="mt-2">
            <div>
              <ImageUploader
                hideRecommendedText
                uploadUrl={data[selected_id]?.additional_pointers_cover}
                setUploadUrl={(url) => {
                  if (error_object?.additional_pointers_cover) {
                    set_error_object({
                      ...error_object,
                      additional_pointers_cover: false,
                    });
                  }
                  updateData(url, formData.bannerImage.key);
                }}
                fullWidth={600}
                hoverText="Upload Image"
                width={150}
                height={100}
                customDefaultImage={placeholderImg}
                borderRadius="4px"
                query={"brand"}
                id="pointers_cover_image"
                uploadViaOptimization
                sectionName={IMAGE_SECTION_KEY_PATH.HOME_PAGE}
              />
              {error_object?.additional_pointers_cover && (
                <div className={`text-danger small`}>Required</div>
              )}
            </div>
          </div>
        </div>
      </ExlyModal>
    </div>
  );
};
